(function () {
  'use strict';

  var SELECTOR = '[data-free-shipping-bar]';

  function yen(cents) {
    return '¥' + Math.round(cents / 100).toLocaleString('ja-JP');
  }

  function apply(bar, cart) {
    var threshold = parseInt(bar.dataset.threshold, 10) || 0;
    var total = cart.total_price || 0;
    var remaining = threshold - total;
    var percent = threshold > 0 ? Math.min(100, Math.round((total / threshold) * 100)) : 0;
    var text;
    var price;

    bar.classList.remove('ybs-fsb--empty', 'ybs-fsb--progress', 'ybs-fsb--achieved');

    if (!cart.item_count) {
      bar.classList.add('ybs-fsb--empty');
      text = bar.dataset.msgEmpty;
      price = threshold;
      percent = 0;
    } else if (remaining > 0) {
      bar.classList.add('ybs-fsb--progress');
      text = bar.dataset.msgProgress;
      price = remaining;
    } else {
      bar.classList.add('ybs-fsb--achieved');
      text = bar.dataset.msgAchieved;
      price = 0;
      percent = 100;
    }

    text = String(text || '').split('{price}').join(yen(price));

    var message = bar.querySelector('[data-fsb-message]');
    var fill = bar.querySelector('[data-fsb-fill]');
    if (message) message.innerHTML = text;
    if (fill) fill.style.width = percent + '%';
  }

  function refresh() {
    var bars = document.querySelectorAll(SELECTOR);
    if (!bars.length) return;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        Array.prototype.forEach.call(bars, function (bar) { apply(bar, cart); });
      })
      .catch(function (err) { console.error('[free-shipping-bar]', err); });
  }

  function init() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
    }
    document.addEventListener('cart:update', refresh);
    document.addEventListener('ybs:cart-refresh', refresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.ybsFreeShippingBarRefresh = refresh;
})();